import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { AVAILABILITY_STATUSES } from '../../_shared/AvailabilityStatusSelect'
import FilterLink from '../../../../components/filter/FilterLink'
import FilterListItem from '../../../../components/list/FilterListItem'
import FilterSideModal from '../../../../components/filter/FilterSideModal'

const AvailabilityStatusFilter = () => {
  const { t } = useTranslation('availability')
  const [open, setOpen] = React.useState(false)

  const handleChange = useChangeFilterValue()
  const filter = useFilterValue('availabilityStatus')

  const setStatus = value => handleChange('availabilityStatus', filter === value ? undefined : value)

  return (
    <>
      <FilterLink
        icon="RiFileWarningLine"
        label={t('filterByStatus')}
        value={filter && t(`status.${filter}`)}
        onClick={() => setOpen(true)}
      />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={t('filterByStatus')}
        renderOptions={() =>
          AVAILABILITY_STATUSES.map(status => (
            <FilterListItem
              key={status}
              onClick={() => setStatus(status)}
              label={t(`status.${status}`)}
              isSelected={filter === status}
            />
          ))
        }
      />
    </>
  )
}

export default AvailabilityStatusFilter
